module.exports = __WEBPACK_EXTERNAL_MODULE_76__;


//////////////////
// WEBPACK FOOTER
// external {"root":"moment","commonjs2":"moment","commonjs":"moment","amd":"moment"}
// module id = 76
// module chunks = 0